import React, { Component } from 'react';
import indexOf from 'lodash/indexOf';
import ProjectionStore from '../../../stores/ProjectionStore';

let categoryTags = [];
let userTags = [];

/**
 * @todo
 * The quality of this component is poor. Future improvement work can help
 * to fix this by refactoring the code.
 */
class EssentialSpendingsComponent extends Component {
  constructor(props) {
    super(props);

    this.modifiedTags = this.modifiedTags.bind(this);
    this.modifiedUserTag = this.modifiedUserTag.bind(this);
    this.cbTags = this.cbTags.bind(this);
    this.userTags = this.userTags.bind(this);
  }

  modifiedTags(id) {
    this.props.modifiedTags(id);
  }

  modifiedUserTag(id) {
    this.props.modifiedUserTag(id);
  }

  cbTags() {
    if (this.props.data.essentialSpends !== undefined) {
      categoryTags = ProjectionStore.getCategoryTags();
      let cbTags = this.props.data.essentialSpends.map((cb) => {
        let cbt = cb.categorytags.map((cbtag) => {
          let tagstyle;
          let value = indexOf(categoryTags, cbtag.id);
          let className = value < 0 ? '' : 'selected';
          return (
            <p
              className={className}
              onClick={this.modifiedTags.bind(this, cbtag.id)}
              key={cbtag.id}
              id={cbtag.id}
            >
              {cbtag.tagName}
            </p>
          );
        });
        return cbt;
      });
      return <div className="tags">{cbTags}</div>;
    }
  }

  userTags() {
    if (this.props.data.essentialSpends !== undefined) {
      userTags = ProjectionStore.getUserTags();
      let usertags = this.props.data.essentialSpends.map((user) => {
        let ut = user.usertags.map((usertag) => {
          let tagstyle;
          let value = indexOf(userTags, usertag.id);
          let className = value < 0 ? '' : 'selected';
          return (
            <p
              className={className}
              onClick={this.modifiedUserTag.bind(this, usertag.id)}
              key={usertag.id}
              id={usertag.id}
            >
              {usertag.tagName}
            </p>
          );
        });
        return ut;
      });
      return <div className="tags">{usertags}</div>;
    }
  }

  render() {
    return (
      <div className="full-height">
        <div className="settings-content-wrapper">
          <div id="essential-tab-container">
            <p className="tab-header">
              {this.props.content.projectionSettingsEssentialSpendingHeader}
            </p>
            <div className="tags-container">
              <p className="title-tag">
                {this.props.content.projectionSettingsEssentialSpendingOurTags}
              </p>
              {this.cbTags()}
              <p className="title-tag">
                {this.props.content.projectionSettingsEssentialSpendingYourTags}
              </p>
              {this.userTags()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export { EssentialSpendingsComponent };
